import { AlertTriangle, ArrowRight, Accessibility, CornerDownLeft, Timer } from "lucide-react";
import { fmtTime, statusClass, THEME } from "@/lib/calendar";

export const EventRow = ({ event, variant = "light", onOpen, compact = false, audience = "dispatch" }) => {
  const t = THEME[variant];
  const isReturn = event.leg === "return";
  return (
    <button
      type="button"
      onClick={() => onOpen(event.ride_id)}
      className={`w-full text-left rounded-xl border p-3 transition-colors duration-150 ${t.sub} ${t.hover} ${event.unassigned && audience === "dispatch" ? "border-l-4 border-l-red-500" : ""}`}
      data-testid={`cal-event-${event.ride_id}-${event.leg}`}
    >
      <div className="flex items-start gap-3">
        <div className="w-16 shrink-0">
          <p className={`font-mono font-bold text-sm ${event.time_tbc ? "text-amber-500" : t.accent}`}>{fmtTime(event.time)}</p>
          <span className={`inline-flex items-center gap-1 text-[10px] uppercase tracking-wide font-semibold mt-1 ${isReturn ? "text-orange-500" : t.muted}`}>
            {isReturn && <CornerDownLeft className="w-3 h-3" />}{isReturn ? "Return" : event.has_return ? "Outbound" : "Pickup"}
          </span>
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2 flex-wrap">
            <p className="font-semibold truncate">{event.client_name}</p>
            <span className={`text-[10px] px-2 py-0.5 rounded-full border ${statusClass(event.status, variant)}`}>{event.status.replace("_", " ")}</span>
          </div>
          {!compact && (
            <p className={`text-xs mt-1 flex items-center gap-1 ${t.muted}`}>
              <span className="truncate">{event.from_address}</span>
              <ArrowRight className="w-3 h-3 shrink-0" />
              <span className="truncate">{event.to_address}</span>
            </p>
          )}
          <div className={`flex items-center gap-3 flex-wrap text-xs mt-1 ${t.muted}`}>
            <span>{event.service_label}</span>
            {event.planned_wait_minutes > 0 && <span className="flex items-center gap-1"><Timer className="w-3 h-3" />{event.planned_wait_minutes} min wait</span>}
            {event.accessibility?.length > 0 && <span className="flex items-center gap-1 text-amber-500"><Accessibility className="w-3 h-3" />{event.accessibility.length}</span>}
            {audience === "dispatch" && event.unassigned && <span className="flex items-center gap-1 text-red-500 font-bold"><AlertTriangle className="w-3 h-3" />NO DRIVER</span>}
            {audience !== "driver" && !event.unassigned && <span>Driver: {event.driver_name}</span>}
            {audience === "client" && event.unassigned && <span>Driver to be assigned</span>}
          </div>
        </div>
      </div>
    </button>
  );
};

export default EventRow;
